import React from 'react';
import Icon from './Icon';

// Small inline banner for settings panels that are interactive locally but do NOT
// yet persist to the server (waiting on the matching PHP act). Keeps the user honest
// about what a "save" actually does — no silent data loss.
export default function PanelNotice({ children }) {
    return (
        <div style={{
            display: 'flex', alignItems: 'center', gap: 'var(--s-2)',
            background: 'var(--brand-soft)', border: '1px solid var(--brand)',
            borderRadius: 'var(--r-md)', padding: 'var(--s-3) var(--s-4)',
            margin: '0 0 var(--s-5)', color: 'var(--brand-strong)',
            fontFamily: 'var(--font)', fontSize: 'var(--fs-sm)', direction: 'rtl',
        }}>
            <span aria-hidden="true" style={{ display: 'inline-flex' }}><Icon name="info" size={18} /></span>
            <span>{children}</span>
        </div>
    );
}
